export default __webpack_public_path__ + "static/amatic-sc-v16-latin-regular-4b5fc586e24677ff9a97d033282a3c57.woff";